import { Component, OnInit } from '@angular/core';
import {TranslationService} from "../../../products-categories/services/translation.service";
import {TranslateService} from "@ngx-translate/core";
import {environment} from "../../../../environments/environment";
import {LanguageChangeService} from "../../../products-categories/services/language-change.service";

@Component({
  selector: 'app-flags-list',
  templateUrl: './flags-list.component.html',
  styleUrls: ['./flags-list.component.scss']
})
export class FlagsListComponent implements OnInit {

  currentLanguage: string = '';
  availableLanguages: string[] = [];
  isBelgium = environment.isBelgium;

  constructor(
    private languageChangeService: LanguageChangeService,
    private translationService: TranslationService,
    private translate: TranslateService,
  ) {
    this.availableLanguages = this.translationService.getAvailableLanguages();

    let lang = localStorage.getItem('selectedLanguage');
    if (lang) {
      this.translate.use(lang);
      this.currentLanguage = lang;
    }

  }

  ngOnInit(): void {
  }

  changeLanguage(lang: string): void {
    this.languageChangeService.changeLanguage(lang);

    location.reload();
  }


}
